"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _EmployeeLookupContext = require("../employee-lookup/EmployeeLookupContext");

var _layout = require("../layout");

var _text = require("../text");

var _utils = require("../utils");

var _AvatarImage = _interopRequireDefault(require("./AvatarImage"));

var _AvatarLink = require("./AvatarLink");

var _AvatarName = _interopRequireDefault(require("./AvatarName"));

var _AvatarUsername = _interopRequireDefault(require("./AvatarUsername"));

var _avatarConstants = require("./avatarConstants");

var _interfaces = require("./interfaces");

var _propTypes = require("./propTypes");

var _utils2 = require("./utils");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Avatar = function Avatar(_ref) {
  var id = _ref.id,
      alternateName = _ref.alternateName,
      badgeColor = _ref.badgeColor,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? [] : _ref$children,
      _ref$colorScheme = _ref.colorScheme,
      colorScheme = _ref$colorScheme === void 0 ? _avatarConstants.AvatarDefaultProps.colorScheme : _ref$colorScheme,
      employeeId = _ref.employeeId,
      fullName = _ref.fullName,
      imageAltText = _ref.imageAltText,
      _ref$isUsernameClicka = _ref.isUsernameClickable,
      isUsernameClickable = _ref$isUsernameClicka === void 0 ? _avatarConstants.AvatarDefaultProps.isUsernameClickable : _ref$isUsernameClicka,
      margin = _ref.margin,
      _ref$newTabHiddenText = _ref.newTabHiddenText,
      newTabHiddenText = _ref$newTabHiddenText === void 0 ? _avatarConstants.AvatarDefaultProps.newTabHiddenText : _ref$newTabHiddenText,
      padding = _ref.padding,
      personId = _ref.personId,
      profileImageUrl = _ref.profileImageUrl,
      pronouns = _ref.pronouns,
      _ref$renderLink = _ref.renderLink,
      renderLink = _ref$renderLink === void 0 ? _AvatarLink.defaultRenderLink : _ref$renderLink,
      renderNameWrapper = _ref.renderNameWrapper,
      renderImageWrapper = _ref.renderImageWrapper,
      _ref$showFullName = _ref.showFullName,
      showFullName = _ref$showFullName === void 0 ? _avatarConstants.AvatarDefaultProps.showFullName : _ref$showFullName,
      _ref$showImage = _ref.showImage,
      showImage = _ref$showImage === void 0 ? _avatarConstants.AvatarDefaultProps.showImage : _ref$showImage,
      _ref$showUsername = _ref.showUsername,
      showUsername = _ref$showUsername === void 0 ? _avatarConstants.AvatarDefaultProps.showUsername : _ref$showUsername,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? _avatarConstants.AvatarDefaultProps.size : _ref$size,
      username = _ref.username,
      linkProps = _ref.linkProps;
  var layout = _avatarConstants.layoutConstants[size];
  var isInEmployeeLookup = (0, _react.useContext)(_EmployeeLookupContext.EmployeeLookupContext);
  if (isInEmployeeLookup) layout.nameLineHeight = _avatarConstants.AVATAR_NOCLIPPING_NAME_LINE_HEIGHT;
  var textColor = colorScheme === _interfaces.AvatarColorScheme.Inverted ? _avatarConstants.INVERTED_COLOR_SCHEME.textColor : _avatarConstants.DEFAULT_COLOR_SCHEME.textColor;
  var hasFullName = showFullName && !!fullName;
  var hasNameOrUsername = hasFullName || showUsername;
  var shouldShowPronouns = !!pronouns && hasFullName && [_interfaces.AvatarSize.Medium, _interfaces.AvatarSize.DietLarge, _interfaces.AvatarSize.Large].includes(size);
  var shouldShowAlternateName = !!alternateName && hasFullName && [_interfaces.AvatarSize.Medium, _interfaces.AvatarSize.DietLarge, _interfaces.AvatarSize.Large].includes(size);
  var shouldAnnounceImageAltText = !hasNameOrUsername && imageAltText !== '';
  var maxChildren = shouldShowPronouns ? layout.maxChildren - 1 : layout.maxChildren;

  var renderedChildren = _react.default.Children.toArray(children).slice(0, maxChildren);

  var hasChildren = !!renderedChildren.length;
  var isAvatarOnly = !hasNameOrUsername && !hasChildren;
  var imageAriaLabel;

  if (imageAltText) {
    imageAriaLabel = imageAltText;
  } else if (!!fullName) {
    imageAriaLabel = "Employee: ".concat(fullName);
  } else {
    imageAriaLabel = "Alias: ".concat(username);
  }

  var imageQuery = personId || employeeId || username;
  var imageQueryType = personId ? _utils2.BadgeServiceQueryType.PersonID : employeeId ? _utils2.BadgeServiceQueryType.EmployeeID : _utils2.BadgeServiceQueryType.Login;
  var imageSource = (0, _utils2.buildBadgeImageUrl)(imageQuery, {
    queryType: imageQueryType,
    isFullSize: size === _interfaces.AvatarSize.Large
  });
  var uniqueId = (0, _react.useMemo)(function () {
    return (0, _utils.getUniqueId)();
  }, []);
  var componentId = id || uniqueId;
  var usernameComponent = showUsername && (0, _core.jsx)(_AvatarUsername.default, {
    id: componentId,
    username: username,
    fontSize: layout.nameFontSize,
    fontWeight: layout.nameFontWeight,
    lineHeight: layout.nameLineHeight,
    isUsernameClickable: isUsernameClickable,
    newTabHiddenText: newTabHiddenText,
    colorScheme: colorScheme,
    linkProps: linkProps,
    renderLink: renderLink
  });
  var badgeStyle = (0, _react.useMemo)(function () {
    return badgeColor ? {
      badgeColor: badgeColor,
      badgeBorderWidth: layout.badgeBorderWidth
    } : undefined;
  }, [layout, badgeColor]);
  var uniqueFullNameId = "".concat(_avatarConstants.COMPONENT_FULL_NAME_ID, "-").concat(componentId);
  var avatarNameComponent = hasFullName && (0, _core.jsx)(_AvatarName.default, {
    fullName: fullName,
    showFullName: showFullName,
    pronouns: shouldShowPronouns ? pronouns : undefined,
    colorScheme: colorScheme,
    fontSize: layout.nameFontSize,
    fontWeight: layout.nameFontWeight,
    lineHeight: layout.nameLineHeight,
    alternateName: shouldShowAlternateName ? alternateName : undefined,
    id: componentId,
    hasRenderNameWrapper: !!renderNameWrapper
  });

  if (renderNameWrapper) {
    avatarNameComponent = hasFullName && renderNameWrapper(avatarNameComponent, uniqueFullNameId);
  }

  var avatarImage = showImage && (0, _core.jsx)(_AvatarImage.default, {
    id: componentId,
    badgeStyle: badgeStyle,
    borderRadius: layout.borderRadius,
    source: profileImageUrl ? profileImageUrl : imageSource,
    size: layout.imageSize,
    shouldAnnounceImageAltText: shouldAnnounceImageAltText,
    imageAltText: imageAriaLabel
  });

  if (renderImageWrapper) {
    avatarImage = showImage && renderImageWrapper(avatarImage);
  }

  return (0, _core.jsx)(_layout.Row, {
    id: componentId,
    "data-test-component": "Avatar",
    "data-test-id": "Avatar_".concat(username),
    padding: padding,
    margin: margin,
    alignItems: "center",
    gridGap: (0, _utils.px)(layout.imageSpacing)
  }, avatarImage, !isAvatarOnly && (0, _core.jsx)(_layout.Col, {
    gridGap: layout.spacing,
    justifyContent: "center",
    flex: isInEmployeeLookup ? 1 : undefined,
    width: isInEmployeeLookup ? 0 : undefined
  }, shouldShowPronouns ? (0, _core.jsx)(_layout.Col, null, avatarNameComponent, usernameComponent) : (0, _core.jsx)(_layout.Row, {
    flexWrap: !isInEmployeeLookup ? 'wrap' : undefined,
    alignItems: "center",
    gridGap: "0.4rem"
  }, avatarNameComponent, usernameComponent), renderedChildren.map(function (child, index) {
    return /*#__PURE__*/_react.default.isValidElement(child) && (0, _core.jsx)(_text.Text, {
      lineHeight: layout.lineHeight,
      "data-test-component": "AvatarTextLine",
      fontSize: layout.textFontSize,
      color: textColor,
      key: index
    }, /*#__PURE__*/_react.default.cloneElement(child, {
      lineHeight: layout.lineHeight,
      fontSize: layout.textFontSize
    }));
  })));
};

Avatar.displayName = 'Avatar';
Avatar.defaultProps = _objectSpread({}, _avatarConstants.AvatarDefaultProps);
var AvatarWithDocs = (0, _stencilReactDesc.describe)(Avatar).description('Used to graphically represent Amazonians.');
AvatarWithDocs.propTypes = _objectSpread({}, _propTypes.avatarPropTypes);
var _default = AvatarWithDocs;
exports.default = _default;